import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CreateAccrualLedgerButton } from "@components/settings/AccountingSettings/CreateAccrualLedgerButton";
import { AccrualLedgerSettingsRow } from "@components/settings/AccountingSettings/accrualLedgerSettingsUtils";

export const ActionCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, AccrualLedgerSettingsRow, unknown>) => (
        <ViewTableCell>
            <CreateAccrualLedgerButton entityId={row.original.entity.id} />
        </ViewTableCell>
    ),
);
